import workspace from "../../workspace";
import {isDisabledInPopupShouldBeHidden} from "../../../../../constants";
import {getPointField, isDisabledInPopupWithParents} from "../../../../../helpers/sqftHelper";
import SqftStore from "../../../store/sqftStore";
import config from "../../../store/sqftConfig";
import COLOR_THEMES from "../../../store/colorThemes";
import sqftConfig from "../../../store/sqftConfig";
import sqftEventManager from "../../../store/sqftEventManager";
import BlinkingHighlight from "../../../helpers/commonParts/blink";

export default class ShapeRender {
  __shape;

  constructor(shape) {
    this.__shape = shape;
    this.blink = new BlinkingHighlight;
  }

  render(ctx) {
    // if (sqftStore && sqftStore.getState().loading) return;
    if (workspace && workspace.getState().loading) {
      return
    }
    if (isDisabledInPopupShouldBeHidden() && isDisabledInPopupWithParents(this)) {
      return
    }

    const isShowSlabTool = SqftStore.isSlabMode();
    const shapeState = this.__shape.getState();
    this.renderDevMode(ctx);

    if (isShowSlabTool) {
      return this.__shape.shapeSlab.render(ctx);
    } else if (shapeState.isPointsMovable) {
      return this.__shape.shapeEditable.render(ctx);
    } else if (shapeState.isRotatable) {
      return this.__shape.shapeRotatable.render(ctx);
    } else if (this.__shape.shapeParams !== undefined && this.__shape.shapeParams.shapeCabinet) {
      return this.__shape.shapeCabinet.render(ctx);
    } else if (this.__shape.shapeParams !== undefined && this.__shape.shapeParams.isSpacer && this.__shape.shapeSpacer) {
      return this.__shape.shapeSpacer.render(ctx);
    }

    this.renderRegularShape(ctx);
  }

  renderDevMode = (ctx) => {
    if (config.isDevMode()) {
      // render center pos
      ctx.save();
      ctx.beginPath();
      let pf = getPointField(this.__shape.pos.x, this.__shape.pos.y);
      ctx.arc(pf.x, pf.y, 5, 0, 2 * Math.PI);
      ctx.stroke();
      ctx.closePath();

      ctx.beginPath();
      let shapeCenter = this.__shape.getCenter();
      const pos = getPointField(shapeCenter.x, shapeCenter.y, this.__shape);
      ctx.arc(pos.x, pos.y, 12, 0, 2 * Math.PI);

      ctx.stroke();
      ctx.closePath();
      ctx.restore();

      // render shape group
      if (this.__shape.getSnappedShapeGroup) {
        const renderText = this.__shape.getSnappedShapeGroup() + ".group";
        const mText = ctx.measureText(renderText);
        ctx.wrapText(renderText, pos.x, pos.y, mText, 16);
      }

      // render shape center
      // ctx.beginPath();
      // let position = this.__shape.getOffset();
      // ctx.arc(position.x, position.y, 50, 0, 2 * Math.PI);
      //
      // ctx.stroke();
      // ctx.closePath();
    }
  }

  renderRegularShape = (ctx) => {
    // const scale = sqftConfig.scale;
    // const canvas = sqftStore.getCanvas();
    const lines = this.__shape.getLines();
    const shapeDesign = this.__shape.getDesign();
    const shapeColorSet = this.__shape.getColorset();

    ctx.save();
    ctx.beginPath();
    for (let i = 0; i < lines.length; i++) {
      lines[i].render(ctx, i > 0);
    }
    if (this.__shape.isHovering() && workspace.getHoverShape() === this.__shape) {
      ctx.strokeStyle = shapeColorSet ? shapeColorSet.primary_border : COLOR_THEMES[sqftConfig.activeTheme].primary_hover;
    } else {
      ctx.strokeStyle = shapeColorSet ? shapeColorSet.primary_border : COLOR_THEMES[sqftConfig.activeTheme].primary;
    }
    ctx.lineWidth = 2; // Math.ceil(scale);
    ctx.closePath();
    ctx.stroke();

    if (this.__shape.isHoveringOnlyShape()
      && workspace.getHoverShape()
      && !sqftConfig.highlight.rotateAngle
      && ( sqftEventManager.getCursor().indexOf("move") >= 0
        || sqftEventManager.getCursor().indexOf("rotate-left") >= 0
        || sqftEventManager.getCursor().indexOf("delete") >= 0
      )
    ) {
      if (sqftEventManager.getCursor().indexOf("delete") >= 0 && !workspace.textBoxManager.isBoxActive()) {

        const hoverLine = this.__shape.getHoverSegment(),
          hoverPoint = this.__shape.getHoverPointOnClick();

        // if ((hoverLine && hoverLine.getAttachedItems()) || (hoverPoint && (hoverPoint.getAngle() || hoverPoint.getArcLength()))) {
        if (hoverLine || hoverPoint) {
          ctx.fillStyle = shapeColorSet ? shapeColorSet.primary_hover : shapeDesign.fillColor;
        } else {
          ctx.fillStyle = shapeDesign.redHoverShapeColor;
        }
      } else {
        ctx.fillStyle = shapeColorSet ? shapeColorSet.primary_hover : shapeDesign.hoverShapeColor;
      }
    } else {
      if (this.blink.isHighlightedLightOn) {
        ctx.fillStyle = shapeColorSet ? shapeColorSet.primary_hover : shapeDesign.fillColor;
      } else {
        ctx.fillStyle = shapeColorSet ? shapeColorSet.primary : shapeDesign.fillColor;
      }
    }
    ctx.fill();
    ctx.restore();

    for (let i = 0; i < lines.length; i++) {
      lines[i].renderLineField(ctx); // renderLineField should be called after render method and ctx.fill()
    }

    // red highlight bumpout
    lines.forEach((line) => {
      if (line.isWithBumpout()) {
        if (sqftEventManager.getCursor().indexOf("delete") >= 0 && line.bumpoutOverlay.isHoveringRect() && !workspace.textBoxManager.isBoxActive()) {
          line.bumpoutOverlay.drawBumpoutRect(ctx);
        }
      }
    });

    //green highlight selected part
    if (sqftConfig.highlight.rotateAngle) {
      // todo fix bumpout rotation and remove this
      if (!this.__shape.isWithBumpout() && !this.__shape.isWithBumpout() && !this.__shape.isPointsMoved && this.__shape.rotatedDegrees === 0) {
        /////////////////////////////////////////
        for (const rotateAnglePart of this.__shape.rotateAngleParts) {
          if (this.__shape.isAngleRotatedPartsWithCorner(rotateAnglePart)) {
            continue;
          }
          if (rotateAnglePart.isActive || rotateAnglePart.isHovered) {
            this.__shape.renderAnglePartActive(rotateAnglePart, ctx);
          }
          if (rotateAnglePart.isPulsing) { //green highlight selected part intro
            this.__shape.renderAnglePartActive(rotateAnglePart, ctx);
            setTimeout(() => {
              rotateAnglePart.isPulsing = false;
            }, 1000);
          }
        }
      }
    }

    //render counter?
    // var vertices = [];
    // for (var i = 0; i < lines.length; i++) {
    //   var s = lines[i];
    //   vertices.push([s.from.x, s.from.y]);
    // }
    //var newTriangles = earcut([vertices]);

    if (sqftConfig.workspace.debug) {
      ctx.beginPath();
      // for (var n = 0; n < newTriangles.length; n+=3) {
      //   var lines = new triangle(newTriangles[n], newTriangles[n+1], newTriangles[n+2]);
      //   for (let i = 0; i < lines.length; i++) {
      //     var l = lines[i];
      //     l.init(this.__shape, true); //initialize as temporary line
      //     l.render(ctx, false); //render temp line
      //   }
      // }
      ctx.lineWidth = 1;
      ctx.closePath();
      ctx.strokeStyle = "#FF0000";
      ctx.stroke();
    }
    //return newTriangles;
  };
}
